import * as Yup from "yup";

const PatientSecurityInfoValidation = Yup.object().shape({
  securityInfo: Yup.object()
    .shape({
      mrn: Yup.string().test(
        "MRN_validation",
        "MRN must be alphanumeric",
        (value) => {
          if (!value) {
            return true;
          }
          return /^[a-zA-Z0-9]+$/.test(value);
        }
      ),
      /* .matches(/^[a-zA-Z0-9]+$/, "MRN must be alphanumeric") */
      ssn: Yup.string()
        .max(11)
        .test(
          "SSN_validation",
          "SSN must contain 9 digits with following format 000-00-0000",
          (value) => {
            if (!value) {
              return true;
            }
            return /\d{3}-\d{2}-\d{4}/.test(value);
          }
        ),
      /* .matches(
     /\d{3}-\d{2}-\d{4}/,
     "SSN must contain 9 digits with following format 000-00-0000"
    ), */
    })
    .when(["testTypeId"], {
      is: (testTypeId: number) => {
        return testTypeId === 4 || testTypeId === 7;
      },
      then: (schema) =>
        schema.shape({
          ssn: Yup.string()
            .max(11)
            .test(
              "SSN_validation",
              "SSN must contain 9 digits with following format 000-00-0000",
              (value) => {
                if (!value) {
                  return true;
                }
                return /\d{3}-\d{2}-\d{4}/.test(value);
              }
            )
            .when(["mrn"], {
              is: (mrn: string) => {
                let regex = new RegExp(/^[a-zA-Z0-9]+$/);
                return !mrn || mrn.length === 0 || !regex.test(mrn);
              },
              then: (schema) =>
                schema
                  .required("SSN is required!")
                  .max(11)
                  .matches(
                    /\d{3}-\d{2}-\d{4}/,
                    "SSN must contain 9 digits with following format 000-00-0000"
                  ),
            }),
          // mrn: Yup.string().matches(
          //   /^[a-zA-Z0-9]+$/,
          //   "MRN must be alphanumeric"
          // ),
          mrn: Yup.string().test(
            "MRN_validation",
            "MRN must be alphanumeric",
            (value) => {
              if (!value) {
                return true;
              }
              return /^[a-zA-Z0-9]+$/.test(value);
            }
          ),
        }),
    }),
});

export default PatientSecurityInfoValidation;
